import styled from 'styled-components';

export const FooterWrapper = styled.footer`
  padding: 24px 16px;
  background-color: #0f172a;
  color: #94a3b8;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 13px;
  margin-bottom: env(safe-area-inset-bottom);
`;

export const Copyright = styled.span`
  color: #f8fafc;
  font-weight: 600;
`;

export const SupportText = styled.span`
  color: #94a3b8;
`;
